import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const TreeMonitorLoader: LoadableType<{
	setIsDraggingItem?: (arg: boolean) => void;
	itemType?: string;
}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TreeMonitor" */ '../src/TreeMonitor.tsx'))
			.TreeMonitor,
});
